import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Unauthorized = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
      <h1 className="text-danger display-4 mb-3">403 - Unauthorized</h1>
      <p className="text-secondary lead mb-4">You do not have permission to view this page.</p>
      {!isAuthenticated && (
        <Link to="/signin" className="btn btn-primary">
          Go to Sign In
        </Link>
      )}
    </div>
  );
};

export default Unauthorized;